"use client"

import { useEffect, useState } from "react"
import ChatWindow, { ChatMessage } from "./ChatWindow"

const POLL_INTERVAL_MS = 3000

export default function ChatRoom() {
	const [username, setUsername] = useState<string | null>(null)
	const [messages, setMessages] = useState<ChatMessage[]>([])

	useEffect(() => {
		let cancelled = false
		fetch("/api/trashchat/me")
			.then((res) => res.json())
			.then((data) => {
				if (!cancelled) setUsername(data.username)
			})
		return () => {
			cancelled = true
		}
	}, [])

	useEffect(() => {
		let cancelled = false

		const fetchMessages = async () => {
			try {
				const res = await fetch("/api/trashchat/messages", { cache: "no-store" })
				const data = await res.json()
				if (!cancelled && Array.isArray(data.messages)) {
					setMessages(data.messages)
				}
			} catch {
				// retry on next poll tick
			}
		}

		fetchMessages()
		const interval = setInterval(fetchMessages, POLL_INTERVAL_MS)
		return () => {
			cancelled = true
			clearInterval(interval)
		}
	}, [])

	const handleSend = async (text: string): Promise<string | null> => {
		const res = await fetch("/api/trashchat/messages", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ text }),
		})
		const data = await res.json()
		if (!res.ok) {
			return data.error ?? "Failed to send message."
		}
		setMessages((prev) => [...prev, data.message])
		return null
	}

	const handleLogout = async () => {
		await fetch("/api/trashchat/logout", { method: "POST" })
		setUsername(null)
	}

	return (
		<ChatWindow
			username={username}
			messages={messages}
			onSend={handleSend}
			onAuthed={setUsername}
			onLogout={handleLogout}
		/>
	)
}
